import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import './SelectSite.css';
import { SelectedBuilding, BuildingsListBuilding, NavigationParamsType } from '../../store/building/types';
import { GraphDateRange } from '../../store/utility/types';
import { BuildingActions } from '../../store';

export interface Props {
  buildingsList: BuildingsListBuilding[];
  graphDateRange: GraphDateRange;
  diagGraphDateRange: GraphDateRange;
  selectedBuilding: SelectedBuilding;
  navigationParams: NavigationParamsType;
  changeBuilding(identifier: string): void;
}
export declare type ComposedProps = Props & RouteComponentProps;

export interface State {
  isMenuOpen: boolean;
}

export class SelectSite extends Component<ComposedProps, State> {
  state = {
    selectedBuilding: {} as SelectedBuilding,
    isMenuOpen: false,
  };

  handleCategoryClick = (e: any) => {
    e.preventDefault();
    this.setState((state) => ({
      ...state,
      isMenuOpen: !this.state.isMenuOpen,
    }));
  };

  handleChange = (slug: string) => {
    const { changeBuilding } = this.props;

    this.setState((state) => ({
      ...state,
      isMenuOpen: false,
    }));

    changeBuilding(slug);
  };

  renderDesktopSelectBuilding() {
    const {
      selectedBuilding: { identifier },
      buildingsList,
    } = this.props;
    return (
      <div className="site-selection-desktop">
        <select value={identifier} onChange={(e) => this.handleChange(e.target.value)}>
          {buildingsList.map((building) => (
            <option key={building.identifier} value={building.identifier}>
              {building.name}
            </option>
          ))}
        </select>
      </div>
    );
  }

  renderArrow() {
    const { isMenuOpen } = this.state;
    let arrowClasses = 'site-selection__arrw';
    arrowClasses += isMenuOpen ? ' site-selection__arrw--dwn' : ' site-selection__arrw--up';

    return <span className={arrowClasses} />;
  }

  renderMobileSelectBuilding() {
    const { selectedBuilding } = this.props;
    return (
      <div className="site-selection-mobile">
        <div className="site-selection__title" onClick={this.handleCategoryClick}>
          {selectedBuilding.name}
          {this.renderArrow()}
        </div>
        {this.state.isMenuOpen ? this.renderMobileOptions() : null}
      </div>
    );
  }

  renderMobileOptions() {
    const { selectedBuilding, buildingsList } = this.props;
    return (
      <div className="site-selection__options-wrapper">
        {buildingsList.map((building) => {
          const isSelected = building.name === selectedBuilding.name;

          let siteOptionClasses = 'site-selection__options';
          siteOptionClasses += isSelected ? ' site-selection__options--selected' : '';

          return (
            <div
              id={building.identifier}
              key={building.identifier}
              onClick={() => this.handleChange(building.identifier)}
            >
              <li className={siteOptionClasses}>{building.name}</li>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const {
      selectedBuilding: { name },
      buildingsList,
    } = this.props;

    return (
      <div className="site-selection">
        {buildingsList.length < 2 ? (
          <span className="site-selection__title">{name || 'No Building Data'}</span>
        ) : (
          <div>
            {this.renderDesktopSelectBuilding()}
            {this.renderMobileSelectBuilding()}
          </div>
        )}
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    buildingsList: state.buildingReducer.buildingsList,
    selectedBuilding: state.buildingReducer.selectedBuilding,
    navigationParams: state.buildingReducer.navigationParams,
    graphDateRange: state.utilityReducer.electricalGraphDateRange,
    diagGraphDateRange: state.diagnosticsReducer.graphDateRange,
  };
}

const mapDispatchToProps = {
  changeBuilding: BuildingActions.changeBuilding,
};

const ConnectedSelectSite = connect(mapStateToProps, mapDispatchToProps)(SelectSite);
const ConnectedSelectSiteWithRouter = withRouter(ConnectedSelectSite);

export { ConnectedSelectSiteWithRouter };
